import { Cell, Row } from 'react-sticky-table';

export const TbodyComponent = ({ sticky, children }) => {
    if (sticky) return <>{children}</>;
    return <tbody>{children}</tbody>;
};
export const TrComponent = (props) => {
    const { sticky, children } = props;
    if (sticky && !props.colSpan) return <Row {...props}>{children}</Row>;
    return <tr {...props}>{children}</tr>;
};
export const TdComponent = (props) => {
    const { sticky, children } = props;
    if (sticky && !props.colSpan) return <Cell {...props}>{children}</Cell>;
    return <td {...props}>{children}</td>;
};

export const TheadComponent = ({ sticky, children }) => {
    if (sticky) return <>{children}</>;
    return <thead>{children}</thead>;
};
export const TrHeadComponent = ({ sticky, children, style, className, rowRef }) => {
    if (sticky)
        return (
            <Row ref={rowRef} sstyle={style} className={className}>
                {children}
            </Row>
        );
    return (
        <tr style={style} className={className}>
            {children}
        </tr>
    );
};
export const TdHeadComponent = (props) => {
    const { sticky, children } = props;
    if (sticky) return <Cell {...props}>{children}</Cell>;
    return <td {...props}>{children}</td>;
};
